module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/visible-56b714b279f2b10dcc29e0fd15e46f8d.svg";